import {api} from '../../utils/api'

export default {

    /**
     * Create attribute
     * @param commit
     * @param node_id
     * @param type
     * @param data
     * @returns {*|Promise|Promise<any>}
     */
    create({commit}, {node_id, name, value}) {
        // Api call
        return api.call(commit, 'post', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/attribute/${node_id}`, {name, value}, "SET_ATTRIBUTE");
    },


    /**
     * Update attribute
     * @param commit
     * @param node_id
     * @param type
     * @param data
     * @returns {*|Promise|Promise<any>}
     */
    update({commit}, {attribute_id, value}) {
        // Api call
        return api.call(commit, 'patch', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/attribute/${attribute_id}`, {value}, "SET_ATTRIBUTE");
    },

    /**
     * Update attribute
     * @param commit
     * @param node_id
     * @param type
     * @param data
     * @returns {*|Promise|Promise<any>}
     */
    postChanges({commit}, {attribute_id, value}) {
        // Api call
        return api.call(commit, 'post', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/attribute/changes/${attribute_id}`, {value}, "SET_ATTRIBUTE");
    },

    /**
     * get node attribute
     * @param commit
     * @param node_id
     * @param parent_node_id
     * @param name
     * @param type
     * @returns {*|Promise|Promise<any>}
     */
    loadNodeAttribute({commit}, {node_id, parent_node_id,  name}) {
        // Api call
        return api.call(commit, 'get', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/attribute/${node_id}/${name}/${parent_node_id}`, false, "SET_ATTRIBUTE");
    },

    /**
     * Remove attribute
     * @param commit
     * @param attribute_id
     * @returns {Promise<any>}
     */
    remove({ commit }, {attribute_id}) {

        // Call register
        return api.call(commit, 'delete', '//'+process.env.VUE_APP_CONTENT_API_URL + `/api/attribute/${attribute_id}`, false, 'DELETE_ATTRIBUTE');
    },
}
